import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('auth', ['currentUser', 'isAuthenticated']),
    highlightedNotes() {
      return Object.values(this.artwork.text_notes).reduce((memo, notes) => {
        notes.map((n) => {
          memo[n.id] = /<\/?span[^>]*>/g.test(n.extract);
        });
        return memo;
      }, {});
    },
    notes() {
      return this.rawArtwork.text_notes;
    },
  },
  methods: {
    hierarchy(textNotes) {
      if (textNotes && textNotes.length > 0) {
        const roots = textNotes.filter(this.isRoot);
        let children;
        let sorted = [];

        for (let rootNote of textNotes) {
          if (roots.indexOf(rootNote) > -1) {
            rootNote.root = true;
            sorted.push(rootNote);

            children = textNotes.filter((note) => {
              return this.byExternalId(note, rootNote.id);
            });

            sorted = sorted.concat(children);
          } else if (sorted.indexOf(rootNote) === -1) {
            rootNote.root = true;
            sorted = sorted.concat(rootNote);
          }
        }
        return sorted;
      } else {
        return textNotes;
      }
    },
    isRoot(note) {
      return typeof note.external === 'undefined';
    },
    byExternalId(note, id) {
      return note.external === id;
    },
  },
};
